module.exports = __webpack_public_path__ + "fonts/KrungthaiFastWeb-ExtraBold.3413fb61.eot";